import request from '@/axios';
import { getHeader } from '@/util/util';

// 结算记录详情
export const getSettlementList = (data, oldData) => {
  return request({
    url: '/lebo-ad/adsettle/page',
    method: 'get',
    headers: getHeader(oldData),
    params: data
  })
}

export const getDetail = (id, oldData) => {
  return request({
    url: '/lebo-ad/adsettle/detail',
    method: 'get',
    headers: getHeader(oldData),
    params: {
      id
    }
  })
}

export const remove = (ids, oldData) => {
  return request({
    url: '/lebo-ad/adsettle/remove',
    method: 'post',
    headers: getHeader(oldData),
    params: {
      ids,
    }
  })
}

export const addSettle = (data, oldData) => {
  return request({
    url: '/lebo-ad/adsettle/save',
    method: 'post',
    headers: getHeader(oldData),
    data
  })
}

// 获取用户的信息和权限
export const getMenuPermissions = (data, oldData ) => {
  return request({
    url: '/lebo-ad/adsettle/getMenuPermissions',
    method: 'get',
    headers: getHeader(oldData),
    params: data
  })
}

export const update = (data, oldData) => {
  return request({
    url: '/lebo-ad/adsettle/update',
    method: 'post',
    headers: getHeader(oldData),
    data
  })
}

export const getMaxVersion = (data) => {
  return request({
    url: '/lebo-ad/adsettle/getMaxVersion',
    method: 'get',
    params: data
  })
}
